module.exports = __webpack_public_path__ + "static/media/06_CORTININHA_SEM_BOJO_LISO_07.eb3d6c97.jpg";